export default __webpack_public_path__ + "static/media/circleForegroundRight.34f8c98b.svg";